import { useContext } from "react";

import GuidesContext, { IGuidesService } from "./GuidesContext";

const useGuides = (): IGuidesService => useContext<IGuidesService>(GuidesContext);

export default useGuides;
